import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export const useFileHandler = () => {
  const downloadFile = (base64Data, fileType, fileName) => {
    try {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);

      [...byteCharacters].forEach((char, i) => {
        byteNumbers[i] = char.charCodeAt(0);
      });

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: fileType });

      const extension = fileType.split('/')[1];
      const fullFileName = `${fileName}.${extension}`;

      saveAs(blob, fullFileName);

      return {
        success: true,
        message: 'Archivo descargado exitosamente',
      };
    } catch (error) {
      console.error('Error downloading file:', error);
      return {
        success: false,
        message: 'Error al descargar el archivo',
        error,
      };
    }
  };

  const downloadFilesAsZip = async (files, zipName = 'archivos') => {
    try {
      const zip = new JSZip();

      const processFiles = files.map(async (file, index) => {
        if (file instanceof File || file instanceof Blob) {
          const fileName = file.name || `archivo_${index + 1}`;
          zip.file(fileName, file);
          return;
        }

        if (file.file instanceof File || file.file instanceof Blob) {
          const fileName = file.fileName || file.file.name || `archivo_${index + 1}`;
          zip.file(fileName, file.file);
          return;
        }

        const base64Data = file.base64Data || file.file;
        const { fileType } = file;

        if (!base64Data || !fileType) return;

        try {
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);

          [...byteCharacters].forEach((char, i) => {
            byteNumbers[i] = char.charCodeAt(0);
          });

          const byteArray = new Uint8Array(byteNumbers);
          const extension = fileType.split('/')[1];
          const fullFileName = file.fileName
            ? `${file.fileName}.${extension}`
            : `archivo_${index + 1}.${extension}`;

          zip.file(fullFileName, byteArray);
        } catch (err) {
          console.error(`Error processing file ${index}:`, err);
        }
      });

      await Promise.all(processFiles);

      if (Object.keys(zip.files).length === 0) {
        return {
          success: false,
          message: 'No hay archivos para comprimir',
        };
      }

      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `${zipName}.zip`);

      return {
        success: true,
        message: 'Archivos comprimidos descargados exitosamente',
      };
    } catch (error) {
      console.error('Error downloading zip file:', error);
      return {
        success: false,
        message: 'Error al descargar los archivos comprimidos',
        error,
      };
    }
  };

  return {
    downloadFile,
    downloadFilesAsZip,
  };
};
